// api/aws/deals/computeTotalValuesFn.ts
// Re-exports from centralized dealCalculations for backward compatibility
import { NewDeal, OrganizationTableItem, Product, Totals } from 'types'
import { calculateDealTotals, calculateDealTotalsWithPayments } from 'utils/dealCalculations'

/**
 * @deprecated Use calculateDealTotals from 'utils/dealCalculations' directly
 */
export const computeTotalsBase = (
  d: NewDeal | OrganizationTableItem,
  rows: (Product | OrganizationTableItem)[]
): Totals => {
  return calculateDealTotals(d as NewDeal, rows as Product[])
}

/**
 * @deprecated Use calculateDealTotalsWithPayments from 'utils/dealCalculations' directly
 */
export const computeTotalsFn = (
  deal: NewDeal | OrganizationTableItem,
  rows: (Product | OrganizationTableItem)[]
): Totals & { paymentAmount: number } => {
  return calculateDealTotalsWithPayments(deal as NewDeal, rows as Product[])
}
